import { render, staticRenderFns } from "./ListSpots.vue?vue&type=template&id=0645c500"
import script from "./ListSpots.vue?vue&type=script&lang=js"
export * from "./ListSpots.vue?vue&type=script&lang=js"
import style0 from "./ListSpots.vue?vue&type=style&index=0&id=0645c500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports